import { observable, flow } from "mobx";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import {
  classDetail
} from "../../utils/api/trainingSubjectManage";

class   TrainingSubjectManage {
  @observable loading = false;
  classDetail = flow(function* ({ callback, id }) {
    yield classDetail(id).then(
      (res) => {
        if (res.status === 200) {
          this.loading = false;
          callback && callback(res.data);
        }
      },
      (error) => {
        this.loading = false;
        const { response = {} } = error;
        const { data = {} } = response;
        message.error(data.msg || data.message);
        callback && callback({});
      }
    );
  }).bind(this);
  
}
export default TrainingSubjectManage;
